export { default } from './ManifestationListItem';



// WEBPACK FOOTER //
// ./app/components/search/ManifestationListItem/index.js